import { fullWidthStyles } from "components/components/FullWidthSection/style";
import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";

export const IrisFooter = styled.div`
  display: flex;

  > div {
    max-width: 50%;
    font-size: ${fonts.medium};
    margin-right: 1em;
  }
`;

export const NavContainer = styled.div`
  ${fullWidthStyles};
  background-color: ${colours.lightGrey};
`;
